<template>
  <div class="form-box">
    <div class="structure mt-3">
      <span class="structure__heading mt-2">
        <i
          class="far fa-list mr-2"
          aria-hidden="true"
        />
        {{ $t('global.requestData') }}
      </span>
      <b-row class="mt-2">
        <b-col md="6">
          <div class="structure__data">
            <small>{{ $tc('global.laboratory') }}</small>
            <h4
              qa="request-info-laboratory-h4"
              class="collapsable-card-title"
            >
              {{ request ? request.laboratory.labName : '-' }}
            </h4>
          </div>
        </b-col>
        <b-col md="6">
          <div class="structure__data">
            <small>{{ $t('global.regime') }}</small>
            <h4
              qa="request-info-regime-h4"
              class="collapsable-card-title"
            >
              {{ request.regime ? request.regime.name : '-' }}
            </h4>
          </div>
        </b-col>
        <b-col md="6">
          <div class="structure__data">
            <small>{{ $t('global.episode') }}</small>
            <h4
              qa="request-info-episode-h4"
              class="collapsable-card-title"
            >
              {{ request.episode }}
            </h4>
          </div>
        </b-col>
        <!-- TODO: Pendiente de enlazar cuando el endpoint se amplíe con el número de estudio -->
        <b-col md="6">
          <div class="structure__data">
            <small>{{ $t('component.caseCardModal.studyId') }}</small>
            <h4
              qa="request-info-case-label-h4"
              class="collapsable-card-title"
            >
              {{ request.caseLabel ? request.caseLabel : '-' }}
            </h4>
          </div>
        </b-col>
        <b-col md="6">
          <div class="structure__data">
            <small>{{ $t('global.externalReference') }}</small>
            <h4
              qa="request-info-external-reference-h4"
              class="collapsable-card-title"
            >
              {{ request.externalReference ? request.externalReference : '-' }}
            </h4>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col lg="12">
          <div class="structure__data">
            <small>{{ $t('global.relevantClinicalData') }}</small>
            <h4
              qa="request-info-relevant-clinical-data-h4"
              class="collapsable-card-title"
            >
              {{ request.clinicalData ? request.clinicalData.text : '-' }}
            </h4>
          </div>
        </b-col>
        <b-col lg="12">
          <div class="structure__data">
            <small>{{ $t('global.observations') }}</small>
            <h4
              qa="request-info-observations-h4"
              class="collapsable-card-title"
            >
              {{ request.notes.text ? request.notes.text : '-' }}
            </h4>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <b-row>
            <b-col
              cols="auto"
              class="d-flex align-items-center"
            >
              <span class="ap-title ap-title__divider">{{ $t('global.requester') }}</span>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('component.studyRequest.form.clinicCard.physicianCenter') }}</small>
                <h4
                  qa="request-info-physician-center-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request && request.physicianDepartment ? request.physicianDepartment.center.name : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('component.studyRequest.form.clinicCard.physicianDepartment') }}</small>
                <h4
                  qa="request-info-physician-department-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request && request.physicianDepartment ? request.physicianDepartment.name : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('component.studyRequest.form.clinicCard.petitioner') }}</small>
                <h4
                  qa="request-info-physician-petitioner-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request && request.physicianPetitioner ? request.physicianPetitioner.fullName : '-' }}
                </h4>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-row class="mt-3">
            <b-col
              cols="auto"
              class="d-flex align-items-center"
            >
              <span class="ap-title ap-title__divider">{{ $tc('global.insurance', 1) }}</span>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $tc('global.insurance', 1) }}</small>
                <h4
                  qa="request-info-insurance-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request.insurer ? request.insurer.name : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $tc('global.insuranceDocument') }}</small>
                <h4
                  qa="request-info-insurance-document-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request.insuranceNumber ? request.insuranceNumber : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $tc('global.insurancePolicy') }}</small>
                <h4
                  qa="request-info-insurance-policy-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request.insuranceNumber ? request.insuranceNumber : '-' }}
                </h4>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-row class="mt-3">
            <b-col
              cols="auto"
              class="d-flex align-items-center"
            >
              <span class="ap-title ap-title__divider">{{ $t('registry.cases.destination') }}</span>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('component.studyRequest.form.clinicCard.destinationCenter') }}</small>
                <h4
                  qa="request-info-destination-center-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request && request.destinationDepartment ? request.destinationDepartment.center.name : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('component.studyRequest.form.clinicCard.destinationDepartment') }}</small>
                <h4
                  qa="request-info-destination-department-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request && request.destinationDepartment ? request.destinationDepartment.name : '-' }}
                </h4>
              </div>
            </b-col>
            <b-col
              md="6"
              lg="4"
            >
              <div class="structure__data">
                <small>{{ $t('global.sendTo') }}</small>
                <h4
                  qa="request-info-receiver-h4"
                  class="collapsable-card-title inside"
                >
                  {{ request.reqAttn || request.attn ? request.reqAttn || request.attn : '-' }}
                </h4>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="request.additionalInformation.length"
          cols="12"
        >
          <b-row class="mt-2">
            <b-col
              cols="auto"
              class="d-flex align-items-center"
            >
              <span class="ap-title ap-title__divider">{{ $t('global.supplementaryData') }}</span>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-for="info in request.additionalInformation"
              :key="info.reiId"
              md="6"
              lg="4"
            >
              <small>{{ info.reiTitle }}</small>
              <h4
                v-testing="info.reiTitle"
                class="collapsable-card-title"
              >
                {{ info.reiAnswer }}
              </h4>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="subrequest-box pb-2 mt-2">
      <b-tabs class="vt-tabs">
        <b-tab
          v-for="(subRequest, key) in request.subrequests"
          :id="'samplesCollapsableCard' + subRequest.id"
          :key="key"
        >
          <template slot="title">
            <span v-testing="subRequest.externalId">{{ key | abc }}</span>
          </template>
          <div class="form-box mt-3 pb-3">
            <div class="structure">
              <span class="structure__heading mt-2">
                <i
                  class="far fa-prescription-bottle mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.sampleData') }}
              </span>
              <b-row class="mt-2">
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('registry.requestGrid.subGrid.location' ) }}</small>
                    <h4
                      qa="request-info-location-h4"
                      class="collapsable-card-title inside"
                    >
                      {{ subRequest.topographicCode ? subRequest.topographicCode.description : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.sampleType') }}</small>
                    <h4
                      qa="request-info-sample-type-h4"
                      class="collapsable-card-title inside"
                    >
                      {{ subRequest.sampleType.description }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.procedure') }}</small>
                    <h4
                      qa="request-info-procedure-h4"
                      class="collapsable-card-title"
                    >
                      {{ subRequest.procedure ? subRequest.procedure.description : '-' }}
                    </h4>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.probableDiagnosis') }}</small>
                    <h4
                      qa="request-info-most-likely-h4"
                      class="collapsable-card-title inside"
                    >
                      {{ subRequest.mostLikelyMorphologicCode ? subRequest.mostLikelyMorphologicCode.description : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('global.fragmentsSubmittedNumber') }}</small>
                    <h4
                      qa="request-info-fragments-h4"
                      class="collapsable-card-title inside"
                    >
                      {{ subRequest.fragments ? subRequest.fragments : '-' }}
                    </h4>
                  </div>
                </b-col>
                <b-col
                  md="6"
                  lg="4"
                >
                  <div class="structure__data">
                    <small>{{ $t('component.samplesModal.media') }}</small>
                    <h4
                      qa="request-info-conservation-h4"
                      class="collapsable-card-title inside"
                    >
                      {{ subRequest.conservation ? subRequest.conservation : '-' }}
                    </h4>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="structure__data">
                    <small>{{ $t('global.samplingDate') }}</small>
                    <h4
                      v-if="subRequest.samplingDate"
                      qa="request-info-sampling-date-h4"
                      class="collapsable-card-title"
                    >
                      {{ subRequest.samplingDate | datetime }}
                    </h4>
                    <h4
                      v-else
                      class="collapsable-card-title"
                    >
                      -
                    </h4>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div class="structure__data">
                    <small>{{ $t('global.observations') }}</small>
                    <h4
                      qa="request-info-observations-h4"
                      class="collapsable-card-title"
                    >
                      {{ subRequest.observations || '-' }}
                    </h4>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-row
                    v-if="subRequest.additionalInformation.length || subRequest.subrequestInformations.length"
                    class="mt-2"
                  >
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center"
                    >
                      <span class="ap-title ap-title__divider">{{ $t('global.supplementaryData') }}</span>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row v-if="subRequest.subrequestInformations.length">
                    <b-col
                      v-for="info in subRequest.subrequestInformations"
                      :key="info.seiId"
                      cols="4"
                    >
                      <div class="structure__data">
                        <small>{{ info.formQuestion.question.queQuestion }}</small>
                        <h4
                          v-if="info.formQuestion.question.queQuestionType === DATE_QUESTION_TYPE_ID"
                          v-testing="info.formQuestion.question.queQuestion"
                          class="collapsable-card-title"
                        >
                          {{ info.sriAnswer | datetime }}
                        </h4>
                        <!-- TODO: Revisar esto a nivel front -->
                        <h4
                          v-if="info.formQuestion.question.queQuestionType === MULTISELECT_QUESTION_TYPE_ID"
                          v-testing="info.formQuestion.question.queQuestion"
                          class="collapsable-card-title"
                        >
                          {{ info.formQuestion.question.possibleanswers[info.possibleAnswerPoaId - 1].poaPossibleAnswer }}
                        </h4>
                        <h4
                          v-if="info.formQuestion.question.queQuestionType === INPUT_QUESTION_TYPE_ID"
                          v-testing="info.formQuestion.question.queQuestion"
                          class="collapsable-card-title"
                        >
                          {{ info.sriAnswer }}
                        </h4>
                        <h4
                          v-if="info.formQuestion.question.queQuestionType === TEXTAREA_QUESTION_TYPE_ID"
                          v-testing="info.formQuestion.question.queQuestion"
                          class="collapsable-card-title"
                        >
                          {{ info.sriAnswer }}
                        </h4>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="subRequest.additionalInformation.length">
                    <b-col
                      v-for="info in subRequest.additionalInformation"
                      :key="info.seiId"
                      cols="4"
                    >
                      <div class="structure__data">
                        <small>{{ info.seiTitle }}</small>
                        <h4
                          v-testing="info.seiTitle"
                          class="collapsable-card-title"
                        >
                          {{ info.seiAnswer }}
                        </h4>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
const TEXTAREA_QUESTION_TYPE_ID = 'T'
const MULTISELECT_QUESTION_TYPE_ID = 'S'
const DATE_QUESTION_TYPE_ID = 'D'
const INPUT_QUESTION_TYPE_ID = 'I'
export default {
    name: 'RequestInfo',
    props: {
        request: { type: Object, required: true }
    },
    computed: {
        patient() {
            return this.request.patient
        },
        TEXTAREA_QUESTION_TYPE_ID() {
            return TEXTAREA_QUESTION_TYPE_ID
        },
        MULTISELECT_QUESTION_TYPE_ID() {
            return MULTISELECT_QUESTION_TYPE_ID
        },
        DATE_QUESTION_TYPE_ID() {
            return DATE_QUESTION_TYPE_ID
        },
        INPUT_QUESTION_TYPE_ID() {
            return INPUT_QUESTION_TYPE_ID
        }
    }
}

</script>

<style scoped lang="scss">

.request-info .request-box {
  padding: 5px 15px;
    @include general-card();
}

.request-info .main {
  font-weight: normal;
}

.request-info h4 {
     word-break: break-word;
}

.request-info small {
    display: inline-block;
    line-height: 15px;
}

</style>
